import React, { useEffect, useState } from "react";
import "./Switch.scss";

interface SwitchProps {
  label?: string;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({
  label,
  defaultChecked = false,
  onChange,
  disabled = false,
}: any) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = () => {
    onChange(!checked);
  };

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <div className={`switch-input-container ${disabled ? "disable" : ""}`}>
      <label className="switch-input-label">
        <input
          type="checkbox"
          className="switch-input-checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className="switch-input-slider">
          <span className="switch-input-icon">{checked && "✓"}</span>
        </span>
      </label>
      <span className="switch-input-text">{label}</span>
    </div>
  );
};

export default Switch;
